import { render, staticRenderFns } from "./WorkOrdersStats.vue?vue&type=template&id=dca10c06&"
import script from "./WorkOrdersStats.vue?vue&type=script&lang=js&"
export * from "./WorkOrdersStats.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrdersStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports